import React from 'react'
import ReactMarkdown from 'react-markdown'
import { Link } from 'gatsby';
import ModalVideo from 'react-modal-video'

const Intro = ({intro, video}) => {

    const [isOpen, setIsOpen] = React.useState(true);
     const openModal = () => {
         setIsOpen(!isOpen);
     }
    return (
        <>
        <section className='isbt-container'>
            <div className='isbt-intro container'>
               {
                intro?.map((intro, index) => {
                    return(
                        <div key={index} className='intro-container'>
                            {intro?.heading && <h2 className='text-center font-outfit heading-one'>{intro?.heading}</h2>}
                            <ReactMarkdown>{intro?.description?.data?.description}</ReactMarkdown>
                        </div>
                    )
                })
               }
            </div>
        </section>

        {
            video ? (
                <React.Fragment>
            <ModalVideo
                channel='youtube'
                isOpen={!isOpen}
                videoId={video}
                onClose={() => setIsOpen(!isOpen)}
            />
            <div className='banner-isbt isbt-container'>
                <div className='container my-5'>
                    <div className='banner-item-content mt-0'>
                        <div className="btn-box">
                            <Link to="/demo" className="default-btn">
                                <i className="flaticon-right"></i>
                                Free Demo
                            </Link>
                            <Link
                                to="#play-video"
                                onClick={e => { e.preventDefault(); openModal() }}
                                className="video-btn popup-youtube"
                            >
                                <i className="flaticon-google-play"></i> Watch Video
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            </React.Fragment> 
            ): ""
        }
        
        </>
    )
}

export default Intro